/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { System, Type } from '@lastolivegames/becsy';

import { GlobalComponent } from './global';

export class SpinComponent {}

SpinComponent.schema = {
	object3D: { type: Type.object },
	enabled: { type: Type.boolean, default: true },
	angularSpeed: { type: Type.float32, default: 0.5 },
};

export class SpinSystem extends System {
	constructor() {
		super();
		this.globalEntity = this.query((q) => q.current.with(GlobalComponent));
		this.spinEntities = this.query((q) => q.current.with(SpinComponent).write);
	}

	execute() {
		for (const entity of this.spinEntities.current) {
			const spinComponet = entity.read(SpinComponent);
			if (spinComponet.enabled) {
				//spinComponet.object3D.rotateY(spinComponet.angularSpeed * this.delta);
			}
		}
	}
}
